import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { BasedURL } from "../util/constants";
import NavBar from "./NavBar";
import Footer from "./Footer";

export default function AllNews() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    axios
      .get(`${BasedURL}/news`)
      .then((r) => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <NavBar />
      <main style={{ flex: 1, background: "#f9fafb", paddingBottom: 64 }}>
        <div className="max-w-6xl mx-auto px-4 pt-12">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Projects</h1>
          <p className="text-gray-500 mb-10">Stay up to date with the latest projects from Katsina State SDG Office.</p>

          {loading ? (
            <div className="text-gray-400 text-sm py-12 text-center">Loading…</div>
          ) : items.length === 0 ? (
            <div className="text-gray-400 text-sm py-12 text-center">No projects available yet.</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((item) => (
                <div
                  key={item.id}
                  className="bg-white rounded-2xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
                  style={{ boxShadow: "0 2px 16px rgba(0,0,0,0.08)" }}
                  onClick={() => history.push(`/projects/${item.id}`)}
                >
                  <div style={{ height: 200, background: "#e5e7eb", overflow: "hidden" }}>
                    {item.imageUrl ? (
                      <img
                        src={item.imageUrl}
                        alt={item.title}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    ) : (
                      <div style={{ width: "100%", height: "100%", background: "#d1d5db" }} />
                    )}
                  </div>
                  <div style={{ padding: "16px 20px 22px" }}>
                    {item.category && (
                      <span
                        style={{
                          display: "inline-block",
                          background: "#fef3c7",
                          color: "#92400e",
                          fontSize: 11,
                          fontWeight: 700,
                          borderRadius: 999,
                          padding: "2px 10px",
                          marginBottom: 8,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                        }}
                      >
                        {item.category}
                      </span>
                    )}
                    <h3 style={{ fontSize: 15, fontWeight: 700, color: "#1f2937", marginBottom: 6, lineHeight: 1.4 }}>
                      {item.title}
                    </h3>
                    {item.description && (
                      <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.6, marginBottom: 14 }}>
                        {item.description}
                      </p>
                    )}
                    <button
                      style={{
                        background: "#16a34a",
                        color: "white",
                        border: "none",
                        borderRadius: 6,
                        padding: "6px 18px",
                        fontSize: 13,
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                    >
                      Read More
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
